import effectManager from '../module/effect';

let effect = new effectManager();

/* ------------------------------------------------

    -- 表示センテンスに合わせて固定UIを変更

------------------------------------------------ */

export default class fixedChange {
    constructor(ua) {

        this.ua = ua;

        this.$scrollDown = $("#l-scrolldown");
        this.$pagetopCopyRight = $("#l-pagetop,#l-copyright");

        effect.show(this.$pagetopCopyRight,"set")

        this.changeCntFlg = false;

        /* 色を変更する対象 */
        this.$text = $(".js__sc-ch-text");
        this.$svg = $(".js__sc-ch-svg");
        this.$bg = $(".js__sc-ch-bg");
        this.$border = $(".js__sc-ch-border");


        /* ページネーション */
        this.$navi = $("#l-header-navi-list");
        this.$naviList = $("#l-header-navi-list li");
        effect.skew(this.$naviList,"set");

        this.status = {
            prev : 0
        }

        this.timer = {
            copyright : "",
            scDown    : "",
        }

    }
    changeCnt(current){


        if(current==5){

            if(this.changeCntFlg) return;
            clearTimeout(this.timer.scDown);
            this.changeCntFlg = true;
            TweenMax.killTweensOf(this.$scrollDown)
            this.$scrollDown.removeClass("is-show");
            effect.show(this.$scrollDown,"out");

            let _delay = this.ua === "pc" ? 2e3 : 1e2;

            this.$pagetopCopyRight.addClass("is-show");
            this.timer.copyright = setTimeout(()=> effect.show(this.$pagetopCopyRight,"show"),_delay);


        }else{
            if(!this.changeCntFlg) return;
            clearTimeout(this.timer.copyright);
            this.changeCntFlg = false;
            TweenMax.killTweensOf(this.$pagetopCopyRight)
            effect.show(this.$pagetopCopyRight,"out");
            let _delay = this.ua === "pc" ? 2e3 : 1e2;
            this.$scrollDown.addClass("is-show");
            this.$pagetopCopyRight.removeClass("is-show");
            this.timer.scDown = setTimeout(()=> effect.show(this.$scrollDown,"show"),_delay);
        }

    }
    color(color,current){

        let _color = color=="black" ? "#18191a" : "#fff";


        TweenMax.to(this.$text,0.6,{ color : _color});
        if(current==5&&this.ua=="pc"){
            TweenMax.to(this.$svg.not(".type-logo"),0.6,{ fill : _color});
            TweenMax.to(this.$svg.filter(".type-logo"),0.6,{ fill : "#fff"});
        }else{
            TweenMax.to(this.$svg,0.6,{ fill : _color});
        }
        TweenMax.to(this.$bg,0.6,{ backgroundColor : _color});
        TweenMax.to(this.$border,0.6,{ "border-top-color" : _color});

    }
    pager(current){

        let _current = current-1;

        if(this.status.prev!==_current) {
            effect.skew(this.$naviList.eq(this.status.prev),"out");
            this.$naviList.eq(this.status.prev).removeClass("is-current");
        }
        if(current===0){
            this.$navi.removeClass("is-body");
        }else{
            if(!this.$navi.hasClass("is-body")) this.$navi.addClass("is-body");
            this.$naviList.eq(_current).addClass("is-current");
            effect.skew(this.$naviList.eq(_current),"show");
            this.status.prev = _current;
        }
    }
}